<template>
  <div class="rj-page-card">
    <div class="top-box">
      <div> 产品信息</div>
      <div class="box">
        <span>未申请发货信息</span>
        <el-button type="primary" @click="applyForShipment">
          申请发货
        </el-button>
      </div>
      <el-table v-loading="loading" :data="notTableData" border style="width: 100%" show-summary :summary-method="getSummaries" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
        <el-table-column prop="exclusiveMaterialNumber" label="物品代码" align="left" />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="productNum" label="未发货数量" align="left" />
        <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" width="160" />
        <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="160" />
        <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left">
          <template v-slot="{ row }">
            {{ row.expectedDeliveryDate.substring(0, 10) }}
          </template>
        </el-table-column>
        <el-table-column prop="agreedDate" label="约定交付日期" align="left">
          <template v-slot="{ row }">
            {{ row.agreedDate.substring(0, 10) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="tableData.length">
      <div style="margin-right: 20px;margin:15px 0 5px 0;">
        已申请分批发货信息
      </div>
      <Collapse v-for="(data, index) in tableData" :key="index">
        <div slot="header">
          <div class="headerItem">
            <span>
              配送至：
              {{ data.receiptAddressInfo?.province }}
              {{ data.receiptAddressInfo?.city }}
              {{ data.receiptAddressInfo?.county }}
              {{ data.receiptAddressInfo?.receiptAddress }}
              {{ data.receiptAddressInfo?.receiverName }}
              {{ data.receiptAddressInfo?.receiverPhone }}
            </span>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;实际结算金额总计：{{ data?.settlementAmountTotal }}元
            </span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;发货数量总计：{{ data?.productNumTotal }}</span>
          </div>
        </div>
        <div
          v-for="item in data.strategyShipmentInfos"
          :key="item.id"
        >
          <div class="box-tops">
            <span style="margin-right: 20px;">&nbsp;&nbsp;&nbsp;&nbsp;分批申请单号:&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                style="color: #53a8ff; display: inline-block; cursor: pointer"
                @click="batchApplicationNumber(item)"
              >
                {{ item.deliveryNum }}
              </span>
            </span>
            <span style="margin-right: 20px">申请日期:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.createTime }}</span>
            <span style="margin-right: 20px">发货单号:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.invoiceNum }}</span>
          </div>
          <el-table
            v-loading="loading"
            :data="item.strategyShipmentProducts"
            border
            style="width: 100%;"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              type="index"
              label="序号"
              align="left"
              width="50"
              fixed="left"
            />
            <el-table-column
              prop="materialNumber"
              label="物品代码"
              align="left"
            />
            <el-table-column
              prop="productName"
              label="物品名称"
              align="left"
            />
            <el-table-column prop="productNum" label="数量" align="left" />
            <el-table-column
              prop="productPriceSigle"
              label="实际结算单价"
              align="right"
              header-align="left"
              width="160"
            />
            <el-table-column
              prop="settlementAmount"
              label="实际结算金额"
              align="right"
              header-align="left"
              width="160"
            />
            <el-table-column
              prop="expectedDeliveryDate"
              label="客户期望发货日"
              align="left"
            >
              <template v-slot="{ row }">
                {{ row.expectedDeliveryDate.substring(0, 10) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="agreedDate"
              label="约定交付日期"
              align="left"
            >
              <template v-slot="{ row }">
                {{ row.agreedDate.substring(0, 10) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </Collapse>
    </div>

    <!-- 申请发货 -->
    <sendGoodsDialog ref="sendGoodsDialog" :region-business-commissioner-id="regionBusinessCommissionerId" />

    <!-- 订单详情 -->
    <orderDetails
      ref="orderDetails"
    />
  </div>
</template>
<script type="es6">
import { queryShippingInfoSpecialProducts } from '@/API';
import Collapse from '@/components/Collapse';
import sendGoodsDialog from './sendGoodsDialog.vue';
import orderDetails from '../order-details/index.vue';
import { MathAdd } from '@/libs/util';

export default {
  components: {
    sendGoodsDialog,
    Collapse,
    orderDetails
  },

  props: {
    detailId: {
      type: Number,
      default: 0
    },
    detailData: {
      type: Object,
      required: true
    },
    // 商务员工号
    regionBusinessCommissionerId: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      loading: false,
      tableData: [],
      notTableData: [],
      multipleSelection: [],
      dialogData: { isLoading: false }
    };
  },

  watch: {
    detailId (newVal) {
      this.initDataid(newVal);
    }
  },

  methods: {
    initDataid (val) {
      this.loading = true;
      queryShippingInfoSpecialProducts(val).then((res) => {
        let { status, data } = res.data;
        this.loading = false;
        if (status === '200') {
          this.notTableData = data.unshippedList || [];
          this.tableData = data.strategyShipmentVO || [];
        }
      }).catch(() => {
        this.loading = false;
      });
    },

    applyForShipment () {
      if (!this.multipleSelection.length) {
        return this.$message.warning('请选择发货产品！');
      }
      this.$refs.sendGoodsDialog.openDialog({ tableList: this.multipleSelection }, this.detailData);
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    batchApplicationNumber (val) {
      this.$refs.orderDetails.openDialog(val);
    },
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns && columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.productNum(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.settlementAmount(param.data);
        }
      });
      return sums;
    },

    productNum (target) {
      let cont = 0;
      target && target.forEach((item) => {
        cont = MathAdd(cont, item.productNum);
      });
      return cont;
    },
    settlementAmount (target) {
      let cont = 0;
      target && target.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    }
  }

};
</script>
<style lang="scss" scoped>
.box{
  margin: 5px 0;
  span{
    margin-right: 20px;
  }
}
.Shipped-box{
  height: 40px;
  span{
    font-size: 16px;
    line-height: 40px;
    margin-right: 25px;
  }
}
.box-tops{
  padding: 10px 0;
  border-top: 0;
  border-bottom: 0;
  border-top: 1px solid #EBEEF5;
}

</style>
